import * as requestFromServer from '../common/cruds'
import {FrequencySlices} from './slices'
import {handleNotificationWithToastify} from '../../../app/services/Functional'
import {callTypes, catchError, endCall, startCall} from '../common/slices'

const actions = FrequencySlices.actions
const API_URL = `${process.env.REACT_APP_API_BASE_URL}frequencies/`
const API_URL_INSPECTION = `${process.env.REACT_APP_API_BASE_URL}inspections/`
const API_URL_RESCHEDULED_INSPECTION = `${process.env.REACT_APP_API_BASE_URL}rescheduled-inspections/`

export const getFrequencyById = (id: string, type: string) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .getRequest(`${API_URL}${id}/${type}`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      if (
        Array.isArray(response.data.data.frequency.days) &&
        response.data.data.frequency.days.length > 0
      ) {
        const transformedDays = response.data.data.frequency.days.map((dayObj: any) => dayObj.day)
        response.data.data.frequency.days = transformedDays
      }
      if (
        Array.isArray(response.data.data.frequency.weekdays) &&
        response.data.data.frequency.weekdays.length > 0
      ) {
        const transformedWeekDays = response.data.data.frequency.weekdays.map(
          (dayObj: any) => dayObj.day
        )
        response.data.data.frequency.weekdays = transformedWeekDays
      }
      if (
        Array.isArray(response.data.data.frequency.months) &&
        response.data.data.frequency.months.length > 0
      ) {
        response.data.data.frequency.is_day_wise =
          response.data.data.frequency.months[0].is_day_wise
        if (response.data.data.frequency.months[0].is_day_wise) {
          response.data.data.frequency.day_occurrence =
            response.data.data.frequency.months[0].day_occurrence
          response.data.data.frequency.day_of_week =
            response.data.data.frequency.months[0].day_of_week
        } else {
          response.data.data.frequency.date_occurrence =
            response.data.data.frequency.months[0].date_occurrence
        }
      }
      dispatch(actions.frequency(response.data.data))
    })
    .catch((error) => {
      error.clientMessage = "Can't find frequency"
      dispatch(catchError({error, callType: callTypes.action}))
    })
}

export const createFrequency = (asset_id: string, payload: any) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .postRequest(`${API_URL}${asset_id}`, payload)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      handleNotificationWithToastify(response.data)
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't create frequency"
      dispatch(catchError({error, callType: callTypes.action}))
      return error
    })
}

export const updateFrequency = (id: string, frequency: any) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .patchRequest(`${API_URL}${id}`, frequency)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      handleNotificationWithToastify(response.data)
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't update frequency"
      dispatch(catchError({error, callType: callTypes.action}))
      return error
    })
}

export const deleteInspection = (id: string) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .deleteRequest(`${API_URL_INSPECTION}${id}`)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      handleNotificationWithToastify(response.data)
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't get project list"
      dispatch(catchError({error, callType: callTypes.action}))
      return error
    })
}

export const getInspectionDetailById = (id: string) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .postRequest(`${API_URL_INSPECTION}details/${id}`)
    .then((response) => {
      dispatch(actions.inspectionDetail(response.data.data))
      dispatch(endCall({callType: callTypes.action}))
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't get inspection detail"
      dispatch(catchError({error, callType: callTypes.action}))
      return error
    })
}

export const rescheduleInspection = (payload: any) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .postRequest(`${API_URL_RESCHEDULED_INSPECTION}`, payload)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't reschedule inspection"
      dispatch(catchError({error, callType: callTypes.action}))
      return error
    })
}

export const approveOrRejectInspection = (payload: any) => (dispatch: any) => {
  dispatch(startCall({callType: callTypes.action}))
  return requestFromServer
    .postRequest(`${API_URL_RESCHEDULED_INSPECTION}update-request-status`, payload)
    .then((response) => {
      dispatch(endCall({callType: callTypes.action}))
      return response.data
    })
    .catch((error) => {
      error.clientMessage = "Can't update inspection status"
      dispatch(catchError({error, callType: callTypes.action}))
      return error
    })
}

export const handleResetInspectionDetail = () => (dispatch: any) => {
  return dispatch(actions.resetInspectionDetail())
}

export const handleArrivedFromTheScheduleModule = (value: boolean) => (dispatch: any) => {
  dispatch(actions.setIsArrivedInTheScheduleModule(value))
}
